export const GOOGLE_MAPS_API_KEY = 'AIzaSyAjPvmKbfWBlKhu9q3CW-vCrhL9-bbOAnI'; // FIXME: move this to envs
